import {inlineError} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

export class SendComplaintAdsUseCase extends UseCase {
  constructor({config, sendComplaintAdsRequestFactory, reportAdsRequestFactory, repository}) {
    super()
    this._config = config
    this._sendComplaintAdsRequestFactory = sendComplaintAdsRequestFactory
    this._reportAdsRequestFactory = reportAdsRequestFactory
    this._repository = repository
  }

  @inlineError
  async execute({adId, captchaToken, complaintTypeId, fields: {comments, email, name} = {}} = {}) {
    const {COMPLAINT_TYPE_IDS} = this._config.get('report')

    if (complaintTypeId === COMPLAINT_TYPE_IDS.alreadySoldPrivate) {
      const requestVO = this._reportAdsRequestFactory({
        adId,
        queryTypeId: 2,
        description: comments,
        captchaToken
      })

      return this._repository.reportAd(requestVO)
    }

    const requestVO = this._sendComplaintAdsRequestFactory({
      adId,
      complaintTypeId,
      comments,
      email,
      name
    })

    const [error] = await this._repository.sendComplaint(requestVO)

    if (error) return Promise.reject(error)

    return Promise.resolve()
  }
}
